import { render, staticRenderFns } from "./VoiceNoteChatScreen.vue?vue&type=template&id=ee715e54&scoped=true"
import script from "./VoiceNoteChatScreen.vue?vue&type=script&lang=js"
export * from "./VoiceNoteChatScreen.vue?vue&type=script&lang=js"
import style0 from "./VoiceNoteChatScreen.vue?vue&type=style&index=0&id=ee715e54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee715e54",
  null
  
)

export default component.exports